import { ProductType } from '../common/product/product';
import type { ApiProductType } from './product/product.types';

export function mapProductType(apiProductType: ApiProductType | undefined): ProductType {
    return apiProductType === 'user-based' ? ProductType.USER_BASED : ProductType.ASSET_BASED;
}
